<template>
  <div id="zysk">
    <div class="row section-whitespace">
      <div class="small-10 small-offset-2 medium-offset-1 medium-11 columns">
        <slick class="gold-slider" ref="slick" :options="slickOptions">
          <div class="gold-slide" v-for="(item, index) in items" :key="index">
            <h2>{{ item.title.rendered }}</h2>
            <div v-html="item.content.rendered"></div>
            <router-link class="btn gold-slide__btn" title="Link do oferty" :to="{ path: '/oferta' }">Oferta</router-link>
          </div>
        </slick>
      </div>
    </div>
    <div class="row section-whitespace">
      <div class="small-10 small-offset-2 medium-offset-0 medium-4 columns">
        <img class="svg-icon" src="/static/icons/credit.svg" alt="Kredyt">
        <h3>Kredyt</h3>
        <p>
          Pomimo posiadanych przez Ciebie zasobów finansowych bank nie chce Ci udzielić kredytu? Powierz zarządzanie inwestycją osobie posiadającej udokumentowane doświadczenie – bank musi być po prostu pewien.
        </p>
      </div>
      <div class="small-10 small-offset-2 medium-offset-0 medium-4 columns">
        <img class="svg-icon" src="/static/icons/rise.svg" alt="Płynność finansowa">
        <h3>Płynność finansowa</h3>
        <p>
          Nie chcesz utracić płynności finansowej pomiędzy wyczerpaniem wkładu własnego a możliwością uruchomienia kredytu, a następnie w okresie jego spłaty? Dopasujemy każdy etap inwestycji do Twoich możliwości finansowych.
        </p>
      </div>
      <div class="small-10 small-offset-2 medium-offset-0 medium-4 columns">
        <img class="svg-icon" src="/static/icons/money.svg" alt="Wycena nieruchomości">
        <h3>Wartość nieruchomości gruntowej</h3>
        <p>
          O wartości świadczy nie tylko lokalizacja działki ale również jej rzeczywiste możliwości inwestycyjne. Wydobędziemy z niej ukryte piękno. Pobudzimy zmysł wzroku wraz z logicznym uzasadnieniem atrakcyjności.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  props: {
    id: {
      default: 0,
      type: Number
    }
  },
  data () {
    return {
      items: [],
      slickOptions: {
        slidesToShow: 1,
        arrows: true,
        infinite: false,
        dots: false,
        mobileFirst: true,
        nextArrow: '<button type="button" class="slider__arrow slider__arrow--next"><img src="/static/icons/arrow.svg"></button>',
        prevArrow: '<button type="button" class="slider__arrow slider__arrow--prev"><img src="/static/icons/arrow.svg"></button>',
        adaptiveHeight: true,
        responsive: [
          {
            adaptiveHeight: false,
            breakpoint: 640,
            settings: {
              slidesToShow: 2
            }
          }
        ]
      }
    }
  },
  components: {
    Slick
  },
  beforeCreate: function () {
    this.$http.get(`wp/v2/gain?per_page=100`).then(response => {
      for (let post in response.data) {
        this.items.push(response.data[post])
      }
    }, error => { console.log(error) })
  },
  methods: {
    goTo: function (slideNumber) {
      this.$refs.slick.goTo(slideNumber)
    }
  },
  beforeUpdate () {
    this.$refs.slick.destroy()
  },
  updated () {
    this.$refs.slick.create()
    let slideNumber = this.id
    if (!isNaN(slideNumber)) {
      this.goTo(slideNumber)
    }
  },
  watch: {
    '$route.params.id' (newSlug, oldSlug) {
      let slideNumber = newSlug
      if (!isNaN(slideNumber)) {
        this.goTo(slideNumber)
      }
    }
  }
}
</script>

<style lang="sass">
  @import '../../node_modules/slick-carousel/slick/slick.css';
</style>



// WEBPACK FOOTER //
// src/components/Gain.vue